import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style } from '@vanilla-extract/css';

export const mainContainer = style([
  {
    display: 'flex',
    alignItems: 'center',
    gridColumn: '2 / 4',
    minWidth: 0,
    gap: space.s20,
  },
]);

export const identityInfoContainer = style({
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '100%',
  flexGrow: 1,
  minWidth: 0,
  marginLeft: 0,
  hyphens: 'auto',
});

export const name = style({
  display: 'block',
  hyphens: 'auto',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  width: '100%',
  color: themeVars.container.foreground.primary,

  ...responsiveStyle({
    mobile: {
      ...typography['titleSm'],
    },
    desktop: {
      ...typography['titleLg'],
    },
  }),
});

export const username = style({
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  color: themeVars.container.foreground.secondary,

  ...responsiveStyle({
    mobile: {
      ...typography['bodySm'],
    },
    desktop: {
      ...typography['bodyMd'],
    },
  }),
});

export const actionsContainer = style([
  {
    display: 'flex',
    alignItems: 'center',
  },
  responsiveStyle({
    mobile: {
      gap: space.s6,
    },
    tablet: {
      gap: space.s10,
    },
  }),
]);
